





























import type { PropType } from '@vue/composition-api';
import { defineComponent, computed } from '@vue/composition-api';
import { BrandingHelper } from '../signing-theme/helpers/branding.helper';
import type { SigningTheme } from '../signing-theme/types/theme';

export default defineComponent({
  props: {
    dense: {
      type: Boolean,
    },
    disabled: {
      type: Boolean,
    },
    icon: {
      type: Boolean,
    },
    isLoading: {
      type: Boolean,
    },
    rounded: {
      type: Boolean,
    },
    secondary: {
      type: Boolean,
    },
    disableHover: {
      type: Boolean,
    },
    customHover: {
      type: Boolean,
    },
    isHovered: {
      type: Boolean,
    },
    loadingRecipientInput: {
      type: Boolean,
    },
    theme: {
      type: Object as PropType<SigningTheme>,
      default: null,
    },
  },
  setup(props, { emit }) {
    const handleClick = event => {
      emit('click', event);
    };

    const buttonStyle = computed(() => {
      if (props.theme && props.theme.accentColor) {
        return {
          '--button-background-color': BrandingHelper.getBackgroundColor(
            props.theme.accentColor,
            props.disabled,
            props.secondary
          ),
          '--button-background-color--hover': BrandingHelper.getBackgroundColorHover(
            props.theme.accentColor,
            props.disabled,
            props.secondary
          ),
          '--button-text-color': BrandingHelper.getTextColor(
            props.theme.accentColor,
            props.disabled,
            props.secondary
          ),
          '--button-border-color': BrandingHelper.getBorderColor(
            props.theme.accentColor,
            props.disabled,
            props.secondary
          ),
          '--button-border-color--hover': BrandingHelper.getBorderColorHover(
            props.theme.accentColor,
            props.disabled,
            props.secondary
          ),
        };
      }
      return {};
    });

    const activeCustomHover = computed(() => props.customHover && props.isHovered);

    return { handleClick, buttonStyle, activeCustomHover };
  },
});
